import styled from 'styled-components';

export const StyledSignFieldsDiv = styled.div`
  width: 100%;
  .ant-form-item {
    margin-left: 24px;
  }
`;
